import * as React from "react";
import { Link } from "react-router-dom";
import { decodeHTMLEntities, toRelativeUrl } from "../../../helpers";
import { StyleguideImgPlaceholder } from "../helpers";

type pageHeaderProps = {
  pageType: 'home' | 'update' | 'page';
  isUpdate?: boolean;
  date?: string;
  title: string;
  intro?: string;
  hasImage?: boolean;
  breadcrumbs?: breadcrumbProps;
  color?: "product--comfort" | "product--elan" | "product--leven" | "product--woon"
};

export function pageHeader(props: pageHeaderProps) {
  return ( // TO DO: If content type product, add to header tag the class "product--comfort" || "product--elan" || "product--leven" || "product--woon"
    <header className={`page-header ph ph--${props.pageType}${(props.pageType == 'page' || props.pageType == 'update') && ' ph--secondary'}`}>
      <div className={`ph__outer container container--${props.pageType == 'home' && 'x'}l`}>
        <div className="ph__inner">
          <div className="ph__content content">
            <div className="ph__header">
              <h1 className="ph__title typo--xl">Condimentum Ullamcorper Magna Inceptos Cursus</h1>
              {props.pageType == 'update' && props.date &&
                <time 
                  className="ph__date" 
                  dateTime={props.date}
                >
                  {props.date}
                </time>
              }
              {props.pageType == 'page' && props.intro && 
                <p className="ph__intro">{props.intro}</p>
              }
            </div>
          </div>
          {props.hasImage &&
            <div className="ph__visual visual">
              {props.pageType == 'page' || props.pageType == 'update' ?
                <img className="ph__image" src={StyleguideImgPlaceholder({ shape: { width: 580, height: 580, radius: '0', bgColor: '#FFF' }, text: { color: '#000', font: 'Open Sans, sans-serif' } })} width="580" height="580" alt="" />
                :
                <img className="ph__image" src={StyleguideImgPlaceholder({ shape: { width: 920, height: 600, radius: '0', bgColor: '#9CD1C2' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })} width="920" height="600" alt="" />
              }
            </div>
          }
        </div>
        {props.pageType == 'home' && 
          banner([
            {title: 'Ik zoek een hypothee', url: '/'},
            {title: 'Ik heb een hypotheek', url: '/'},
            {title: 'Ik ben een adviseur', url: '/'}
          ])
        }
        {
          // TODO: breadcrumbs
        }
        {props.pageType == 'update' && props.intro && 
          <div className="ph__intro-wrap">
            <p className="ph__intro">{props.intro}</p>
          </div>
        }
      </div>
    </header>
  )
}

export type bannerProps = bannerArray[];

export type bannerArray = {
  title: string;
  url: string;
}

export function banner(props: bannerProps) {
  return (
    <div className="ph__banner container container--l grid--gutter">
              <ul className="ph__banner banner">
    {props.map((v, i)=> 
      <li className="banner__item" key={`banner-index-${i}`}>
        <a href={v.url} className="banner__link">
          <span className="banner__label">{v.title}</span>
          <svg
          className="banner__icon"
          width="25px"
          height="14px"
          aria-hidden="true"
          >
            <use xlinkHref="#icon--arrow" />
          </svg>
        </a>
      </li>)}
    </ul>
    </div>

  )
}

export type breadcrumbProps = breadcrumbArray[];

export type breadcrumbArray = {
  title: string;
  url: string;
}

export function breadcrumb(props: breadcrumbProps) {
  return (
    <div className="breadcrumbs bc">
      <div className="bc__inner container container--l">
        <ul className="bc__list">
          <li className="bc__item">
            <Link to={toRelativeUrl('/')} className="bc__link">
              <span>{decodeHTMLEntities('Home')}</span>
              <svg
                className="bc__icon"
                width="8px"
                height="5px"
                aria-hidden="true"
              >
                <use xlinkHref="#icon--chevron" />
              </svg>
            </Link>
          </li>
          {props.map((v, i)=> 
            <li className="bc__item" key={`bc-index-${i}`}>
              <Link to={toRelativeUrl(v.url)} className="bc__link">
                <span>{decodeHTMLEntities(v.title)}</span>
                <svg
                  className="bc__icon"
                  width="8px"
                  height="5px"
                  aria-hidden="true"
                >
                  <use xlinkHref="#icon--chevron" />
                </svg>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./Client/styleguide/components/components/pageHeader.tsx